<template>
  <h1 class="text-center">{{$t('heading')}}</h1>
</template>
<script>
export default {
  metaInfo() {
    return { title: this.$_t("pages:500.meta") };
  },
  i18nOptions: {
    namespaces: "pages",
    keyPrefix: "500",
  },
};
</script>